import { createRefresh } from "react-auth-kit"
import { getRefreshTokenInterval } from "./token"
import { AUTH_KEY } from "../consts/auth"
// Use orchestrator so only one tab refreshes
import { refreshForAuthKit } from "./tokenRefreshOrchestrator"

const getRefreshApi = () => {
  let currentAuthState = {}
  let interval = 10

  try {
    // retrieve the token directly from the local storage
    // because it can't access the auth store yet.
    const authState = localStorage.getItem(`${AUTH_KEY}_state`)
    if (authState) {
      currentAuthState = JSON.parse(authState)
      interval = getRefreshTokenInterval(currentAuthState?.lifespan)
    }
  } catch {}

  return createRefresh({
    interval,
    // react-auth-kit expects its own payload shape
    refreshApiCallback: () => refreshForAuthKit({ currentAuthState }),
  })
}

export default getRefreshApi
